import { AppInjector } from './../../app-injector';
import { ApiUrl } from './../api-url.service';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ServiceProvider } from '../service.provider';
import {Observable} from "rxjs";
import {PreloaderService} from "../../common/services/preloader/preloader.service";
import {catchError, map, tap} from "rxjs/operators";
import Collection from "../../models/Collection";
import CartruleMenu from "../../models/CartruleMenu";
import Cartrule from "../../models/Cartrule";

@Injectable()
export class CartruleService extends ServiceProvider {

  protected url = '/api/v1/cartrules';

  constructor(
  ) {
    super(
      AppInjector.get(HttpClient),
      AppInjector.get(ApiUrl),
      'Cartrule'
    );
  }
  listMenus(): Observable<any> {
    return this.http.get(`${this.apiUrl.getApiUrl(this.url)}/list/menus`).pipe(
      map(result => new CartruleMenu((result as any).data)),
      catchError(error => {
        throw error;
      })
    );
  }
  listTemplates(): Observable<any> {
    return this.http.get(`${this.apiUrl.getApiUrl(this.url)}/templates`).pipe(
      map(result => (result as any).data.map(s => new Cartrule(s))),
      catchError(error => {
        throw error;
      })
    );
  }
}
